import type { Highlight, Media } from '../api/types'
import { standbildAdresse } from './video'

/**
 * The point's cover -- the medium the server named (`cover_media_id`,
 * 1.78.0).
 *
 * Until here the map took `media[0]`, and the card under a post took the
 * medium with the lowest id, spot photos included. The two ran apart: after
 * re-ordering, or with an older chat photo added later, the chat showed
 * another picture than the map; a point with only a spot photo had a picture
 * in the chat and none on the map; and with a voice message first, neither
 * showed one although photos followed. The rule is the server's now, and
 * this only looks it up.
 */
export function deckblattVon(highlight: Pick<Highlight, 'media' | 'cover_media_id'>): Media | undefined {
  if (highlight.cover_media_id === undefined || highlight.cover_media_id === null) return undefined
  return highlight.media.find((m) => m.id === highlight.cover_media_id)
}

/**
 * The picture for the pin -- a plain `<img>` in Leaflet's HTML, which asks
 * once and never again. So a video shows its poster only when it is there;
 * the card (`Standbild`) may ask for the address it will have, the pin not.
 */
export function nadelbildVon(highlight: Pick<Highlight, 'media' | 'cover_media_id'>): string | null {
  const deckblatt = deckblattVon(highlight)
  if (deckblatt === undefined) return null
  return deckblatt.kind === 'video' ? deckblatt.poster_url : standbildAdresse(deckblatt)
}
